const fetchDocumentExtractTemplates = async ({ commit, rootGetters, dispatch }) => {
  commit('SET_DOCUMENT_EXTRACT_TEMPLATES_LOADING', true);
  try {
    const customer = rootGetters['customer/CUSTOMER'];
    const selected_customer = rootGetters['customer/SELECTED_CUSTOMER'];

    let url = '/proxy/ai/document-analysis/extract-templates';
    let customer_id = customer.customer_id;

    if (customer.customer_id === 0) {
      customer_id = selected_customer.customer_id;
    }

    url += `?customer_id=${customer_id}`;

    const response = await window.axios.get(url);

    if (response && response.data.success) {
      commit('SET_DOCUMENT_EXTRACT_TEMPLATES', response.data.data.extractTemplates);
    } else {
      throw response.data;
    }
  } catch (error) {
    dispatch('notifications/setError', error.message || 'Failed to fetch extract templates', { root: true });
  } finally {
    commit('SET_DOCUMENT_EXTRACT_TEMPLATES_LOADING', false);
  }
};

export default fetchDocumentExtractTemplates;